import {
  Flex,
  Icon,
  spaces,
  Text,
  Tooltip,
  useBreakpoint,
} from '@electricjs/arc';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { UnavailableInfoChip } from '@/components/Assets/AssetDetails/UnavailableInfoChip';
import { TextVariant } from '@electricjs/arc/components/Text';

type DetailProps = {
  label: string | ReactNode;
  value: string | ReactNode;
  labelTooltip?: string;
  fixed?: boolean;
  disabled?: boolean;
  labelVariant?: TextVariant;
  valueVariant?: TextVariant;
};

const AssetDetail = ({
  label,
  value,
  fixed,
  labelTooltip,
  disabled = false,
  labelVariant = 'label-large',
  valueVariant = 'body',
}: DetailProps) => {
  const { t } = useTranslation('assets');
  const { xl } = useBreakpoint();
  const { space_xs, space_m } = spaces;

  const getValue = () => {
    return typeof value === 'string' ? (
      <Tooltip
        content={t('assetDetails.populatedByElectricApp')}
        disabled={!fixed}
        placement="top">
        <Text
          intent={fixed ? 'disabled' : 'primary'}
          textAlign={xl ? 'start' : 'end'}
          variant={valueVariant}
          preventWidows>
          {value}
        </Text>
      </Tooltip>
    ) : (
      value
    );
  };

  const getLabel = () => {
    if (typeof label === 'string') {
      return (
        <>
          <Text variant={labelVariant}>{label}</Text>
          {labelTooltip && (
            <Tooltip
              content={labelTooltip}
              placement="top-start"
              display="flex"
              maxWidth="400px">
              <Icon icon="information-circle" size="small" ml={space_xs} />
            </Tooltip>
          )}
        </>
      );
    }

    return label;
  };

  return (
    <Flex width="100%" px={space_m} justifyContent="space-between">
      <Flex width="50%" alignItems="center">
        {getLabel()}
      </Flex>
      <Flex width="50%" justifyContent={xl ? 'flex-start' : 'flex-end'}>
        {disabled ? <UnavailableInfoChip /> : getValue()}
      </Flex>
    </Flex>
  );
};

export default AssetDetail;
